import { useGetApplication } from 'app/hooks';

import { type HomeTemplate } from '../models/homeTemplate.model';

interface ResponseValuesExtend {
  data?: HomeTemplate;
  loading: boolean;
  error: any;
  response?: any;
  execute: any;
}

export const useGetHomeTemplate: (
  id: string,
  type: string,
  onLoadMode?: boolean,
  ignoreCDN?: boolean
) => ResponseValuesExtend = (
  id: string,
  type: string,
  onloadMode?: boolean,
  ignoreCDN?: boolean
) => {
  const [{ data, loading, error, response }, execute] = useGetApplication<HomeTemplate>(
    {
      url: '/template/home',
      params: {
        type: type,
        ...(ignoreCDN && {
          language: id,
          ignoreCDN: !!ignoreCDN
        })
      }
    },
    onloadMode === undefined ? true : onloadMode
  );

  return { loading, data, error, response, execute };
};
